export default {
  path: '/lvy-privacy-policy-abstract',
  component: () => import('./LVYPrivacyPolicyAbstract'),
  meta: {
    title: '青藤之恋隐私政策摘要',
    designWidth:750,
    expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (中国标准时间)',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
